<div class="title">{{ model.title }}</div>
<div class="publisher-status-container">
  <div class="publisher-container">
    <app-avatar-or-initials [avatarBase64]="model.publisher.data" [initials]="model.publisher.initials">
    </app-avatar-or-initials>
    <ion-label>{{ model.publisher.displayName }}</ion-label>
  </div>
  <div class="created-container">
    <ion-img src="/assets/icon/date-icon.svg"></ion-img>
    <ion-label>{{ model.createdOn | date: 'dd MMM yy' }}</ion-label>
  </div>
  <div class="open-container">
    <div class="status-circle" [ngClass]="{ closed: !model.isOpen }"></div>
    <ion-label>{{ model.isOpen ? 'open' : 'closed' }}</ion-label>
  </div>
</div>

<hr />

<div class="status-container">
  <div class="type-status">
    <app-slip-type [slipType]="model.type"></app-slip-type>
    <app-slip-component-status [status]="model.componentStatus"></app-slip-component-status>
  </div>
  <div class="due-amount">
    <div class="icon-label due" [ngClass]="{ overdue: model.dueOn?.overdue }">
      <ion-img src="/assets/icon/due-date-icon.svg"></ion-img>
      <ion-label>{{ model.dueOn ? (model.dueOn.date | date: 'dd MMM yy') : '-' }}</ion-label>
    </div>
    @if (model.cost) {
      <div class="icon-label cost">
        <ion-img src="/assets/icon/cost-icon.svg"></ion-img>
        <app-monetary-value [value]="model.cost / 100"></app-monetary-value>
      </div>
    }
  </div>
</div>

<div class="additional-info">
  <div class="heading">Additional Info</div>
  <app-expandable-para [content]="model.description"></app-expandable-para>
</div>
